import { render, staticRenderFns } from "./UserPhotoboothPhotos.vue?vue&type=template&id=fd05d5b2&scoped=true&"
import script from "./UserPhotoboothPhotos.vue?vue&type=script&lang=js&"
export * from "./UserPhotoboothPhotos.vue?vue&type=script&lang=js&"
import style0 from "./UserPhotoboothPhotos.vue?vue&type=style&index=0&id=fd05d5b2&prod&scoped=true&lang=scss&"
import style1 from "./UserPhotoboothPhotos.vue?vue&type=style&index=1&id=fd05d5b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd05d5b2",
  null
  
)

export default component.exports